
import { IconButton, Popover } from '@material-ui/core';
import { InfoOutlined } from '@material-ui/icons';
import { useState } from 'react';
import React from 'react';

export const MuvInstructionsPopover = ({ checkInfo, text, html, htmlTitle }) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleOpen = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    const open = Boolean(anchorEl);

    return (
        <>
            <IconButton onClick={handleOpen} style={{ marginLeft: 5, height: 15, width: 15, marginTop: -10 }}>
                <InfoOutlined style={{ height: 15, width: 15, color: 'var(--mainGreen)' }} />
            </IconButton>
            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                style={{ zIndex: 999999 }}
                PaperProps={{
                    style: {
                        maxWidth: 450,
                        maxHeight: 500,
                        overflowY: 'auto',
                        padding: '16px',
                        border: "1px solid #E8E8E8",
                        boxShadow: "none",
                        zIndex: 999999,
                    },
                }}
            >
                {checkInfo?.checkin?.instructions && !text && (
                    <div style={{ marginBottom: 16 }}>
                        <div style={{ font: "18px/24px Futura Hv BT", color: "#191919", marginBottom: 10 }}>
                            Instructions
                        </div>
                        <div
                            dangerouslySetInnerHTML={{ __html: checkInfo?.checkin?.instructions }}
                            style={{ font: "16px/22px Futura Lt BT", color: "#929292" }}
                        />
                    </div>
                )}
                {checkInfo?.checkin?.special_instructions && !text && (
                    <div>
                        <div style={{ font: "18px/24px Futura Hv BT", color: "#191919", marginBottom: 10 }}>
                            Special Instructions
                        </div>
                        <div
                            dangerouslySetInnerHTML={{ __html: checkInfo?.checkin?.special_instructions }}
                            style={{ font: "16px/22px Futura Lt BT", color: "#929292" }}
                        />
                    </div>
                )}

                {checkInfo?.fees?.mandatory && !text && (
                    <div>
                        <div style={{ marginTop: 10, font: "18px/24px Futura Hv BT", color: "#191919", marginBottom: 10 }}>
                            Mandatory Fees
                        </div>
                        <div
                            dangerouslySetInnerHTML={{ __html: checkInfo?.fees?.mandatory }}
                            style={{ font: "16px/22px Futura Lt BT", color: "#929292" }}
                        />
                    </div>
                )}

                {checkInfo?.fees?.optional && !text && (
                    <div>
                        <div style={{ marginTop: 10, font: "18px/24px Futura Hv BT", color: "#191919", marginBottom: 10 }}>
                            Optional Fees
                        </div>
                        <div
                            dangerouslySetInnerHTML={{ __html: checkInfo?.fees?.optional }}
                            style={{ font: "16px/22px Futura Lt BT", color: "#929292" }}
                        />
                    </div>
                )}

                {html && !text && (
                    <div>
                        {htmlTitle && <div style={{ marginTop: 10, font: "18px/24px Futura Hv BT", color: "#191919", marginBottom: 10 }}>
                            {htmlTitle}
                        </div>}
                        <div
                            dangerouslySetInnerHTML={{ __html: html }}
                            style={{ font: "16px/22px Futura Lt BT", color: "#929292" }}
                        />
                    </div>
                )}


                {text && (
                    <div>
                        {/* <div style={{ font: "18px/24px Futura Hv BT", color: "#191919", marginBottom: 10, marginTop: 10 }}>
                            Taxes and Fees
                        </div> */}
                        <div

                            style={{ font: "16px/22px Futura Lt BT", color: "#929292" }}>
                            {text}
                        </div>
                    </div>
                )}
            </Popover>
        </>
    );
};
